<template>
  <div class="airport-vehicle-management">
    <top-nav :banner="data.banner" color="#333333" isParent></top-nav>
    <pain></pain>
    <tech-empowerment></tech-empowerment>
    <comm-scene :dataKey="'airport-vehicle-management'" scene-key="applicationScenarios"></comm-scene>
    <self-developed-products></self-developed-products>
    <customer-wall></customer-wall>
    <footer-resolution></footer-resolution>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pain from './components/pain.vue';
import TechEmpowerment from './components/tech-empowerment.vue';
import SelfDevelopedProducts from './components/self-developed-products.vue';
import CustomerWall from '@/views/index-view/customer-wall.vue';

export default {
  components: {
    Pain,
    TechEmpowerment,
    SelfDevelopedProducts,
    CustomerWall
  },
  computed: {
    ...mapGetters(['globalData']),
    data() {
      return this.globalData['airport-vehicle-management'];
    }
  }
};
</script>

<style lang="scss" scoped>
.airport-vehicle-management {
  background: #ffffff;

  ::v-deep .banner-item-brief {
    width: 40%;
    color: #909399;
    font-size: 24px;
    line-height: 1.5;
  }
  ::v-deep .banner-list .banner-item .banner-buttons {
    bottom: 20%;
  }
}
</style>
